export const adverseEventCvmSearchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance',
    'displayedColumns': 'default',
    'direction': 'asc'
  },
  {
    'value': '^root_adverseEvent',
    'display': 'Adverse Events, Ascending',
    'displayedColumns': 'adverseEvent',
    'direction': 'asc'
  },
  {
    'value': '$root_adverseEvent',
    'display': 'Adverse Events, Descending',
    'displayedColumns': 'adverseEvent',
    'direction': 'desc'
  },
  {
    'value': '^root_species',
    'display': 'Species, Ascending',
    'displayedColumns': 'species',
    'direction': 'asc'
  },
  {
    'value': '$root_species',
    'display': 'Species, Descending',
    'displayedColumns': 'species',
    'direction': 'desc'
  },
  {
    'value': '^root_aeCount',
    'display': 'Adverse Event Count, Ascending',
    'displayedColumns': 'adverseEventCount',
    'direction': 'asc'
  },
  {
    'value': '$root_aeCount',
    'display': 'Adverse Event Count, Descending',
    'displayedColumns': 'adverseEventCount',
    'direction': 'desc'
  },
  {
    'value': '^root_routeOfAdmin',
    'display': 'Route of Admin, Ascending',
    'displayedColumns': 'routeOfAdmin',
    'direction': 'asc'
  },
  {
    'value': '$root_routeOfAdmin',
    'display': 'Route of Admin, Descending',
    'displayedColumns': 'routeOfAdmin',
    'direction': 'desc'
  },
  {
    'value': '^root_name',
    'display': 'Ingredient, Ascending',
    'displayedColumns': 'ingredientName',
    'direction': 'asc'
  },
  {
    'value': '$root_name',
    'display': 'Ingredient Name, Descending',
    'displayedColumns': 'ingredientName',
    'direction': 'desc'
  }
];
